import {
  MAX_FUTURE_MS,
  fromDateTimeLocalValue,
  spentAtError,
  spentAtOf,
  toDateTimeLocalValue,
} from "./spent-at";

export const spentAtMessages = {
  invalid: "Bitte gib einen gültigen Zeitpunkt ein.",
  future: "Der Zeitpunkt darf höchstens einen Tag in der Zukunft liegen.",
};

export const initialSpentAtInput = (entry, now = Date.now()) =>
  toDateTimeLocalValue(entry?.id ? spentAtOf(entry) : now);

export const maxSpentAtInput = (now = Date.now()) =>
  toDateTimeLocalValue(now + MAX_FUTURE_MS);

// Untouched: an edit keeps the stored time, a new entry gets the moment of saving.
export const resolveSpentAt = ({
  value,
  initialValue,
  isEdit,
  now = Date.now(),
}) => {
  if (value === initialValue) {
    return { spentAt: isEdit ? undefined : new Date(now).toISOString() };
  }
  const iso = fromDateTimeLocalValue(value);
  if (!iso) return { error: spentAtMessages.invalid };
  const error = spentAtError(iso, now);
  if (error) return { error: spentAtMessages[error] };
  return { spentAt: iso };
};
